function createEvent() {
    const callbacks = [];
    const off = (callback) => {
        const idx = callbacks.indexOf(callback);
        if (idx === -1)
            return;
        callbacks.splice(idx, 1);
    };
    const on = (callback) => {
        callbacks.push(callback);
        return () => off(callback);
    };
    const once = (callback) => {
        const stop = on(() => {
            stop();
            callback();
        });
    };
    const trigger = (...args) => {
        callbacks.forEach((cb) => {
            cb(...args);
        });
    };
    return { off, on, once, trigger };
}
const viewMountedEvent = createEvent();

export { viewMountedEvent };
